<div id="edit-popup" tabindex="-1" aria-hidden="true" class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-modal md:h-full">
  <div class="relative p-4 w-full max-w-2xl h-full md:h-auto">
    <!-- Modal content -->
    <div class="relative p-4 bg-white rounded-lg shadow dark:bg-gray-800 sm:p-5">
      <!-- Modal header -->
      <div class="flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 dark:border-gray-600">
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
          Erstelle eine Reason
        </h3>
        <button type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white" id="close-modal">
          <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
          <span class="sr-only">Schliesen</span>
        </button>
      </div>
      <!-- Modal body -->
      <form action="#">
        <div class="grid gap-4 mb-4 sm:grid-cols-2">
          <div>
            <label for="title" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Titel</label>
            <input type="text" name="title" id="title" [formControl]="title" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" >
          </div>
          <div>
            <label for="description" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Reason</label>
            <input type="text" name="description" id="description" [formControl]="description" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" >
          </div>
          <div>
            <label for="topic" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Warum</label>
            <select id="topic" (change)="selectTopicChange($event)" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500">
              @for (topic of topics; track topic.id){
                @if(topic.id === topicId){
                  <option [ngValue]="topic.id" selected>{{topic.topicname}}</option>
                } @else {
                  <option [ngValue]="topic.id">{{topic.topicname}}</option>
                }
              }
            </select>
          </div>
          <div>
            <label for="user" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Für</label>
            <select id="user" (change)="selectChange($event)" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500">
              <option>Jeder</option>
              @for (user of users; track user.id){
                @if(user.id === selectedUser?.id){
                  <option [ngValue]="user.id" selected>{{user.username}}</option>
                } @else {
                  <option [ngValue]="user.id">{{user.username}}</option>
                }
              }
            </select>
          </div>
        </div>
        <div class="flex items-center space-x-4">
          <button id="save-button" type="submit" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">
            Änderungen Speichern
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
